import React, { useState } from 'react';
import './PasswordModal.css';

const PasswordModal = ({ onClose, onJoin, loading, t }) => {
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password.trim()) {
      onJoin(password);
    }
  };

  const handleClose = () => {
    setPassword('');
    onClose();
  };

  return (
    <div className="password-modal-overlay">
      <div className="password-modal-container">
        <div className="password-modal-header">
          <h2 className="password-modal-title">
            {t('passwordRequired', 'Password Required')}
          </h2>
          <p className="password-modal-subtitle">
            {t('tournamentPasswordProtected', 'This tournament is password protected')}
          </p>
        </div>
        
        <form onSubmit={handleSubmit} className="password-modal-form">
          <div className="password-field">
            <label className="password-label">
              {t('enterPassword', 'Enter Password')}
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('enterPassword', 'Enter password...')}
              className="password-input"
              disabled={loading}
              autoFocus
            />
          </div>
          
          <div className="password-modal-actions">
            <button
              type="submit"
              disabled={loading || !password.trim()}
              className="password-join-button"
            >
              {loading ? t('joining', 'Joining...') : t('joinTournament', 'Join Tournament')}
            </button>
            
            <button
              type="button"
              onClick={handleClose}
              disabled={loading}
              className="password-cancel-button"
            >
              {t('cancel', 'Cancel')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PasswordModal;